import { Navigate } from 'react-router'

import { useAuth } from '../auth/AuthContext'

const Login: React.FC = () => {
  const { me, loading } = useAuth()

  if (loading) return <p className="text-gray-500">Loading…</p>
  if (me) return <Navigate to="/" replace />

  return (
    <section className="mx-auto max-w-md">
      <h1 className="mb-4 text-2xl font-semibold">Log in</h1>
      <p className="text-gray-700">
        To access snacks, ask the admin to run{' '}
        <code className="rounded bg-gray-100 px-1.5 py-0.5 text-sm">
          pnpm user:link &lt;your-email&gt;
        </code>{' '}
        and open the URL they send you.
      </p>
      <p className="mt-3 text-sm text-gray-500">
        For programmatic access, ask the admin to run{' '}
        <code className="rounded bg-gray-100 px-1.5 py-0.5 text-sm">
          pnpm token:add &lt;your-email&gt; [label]
        </code>{' '}
        and use the printed token as a Bearer token in the{' '}
        <code className="rounded bg-gray-100 px-1.5 py-0.5 text-sm">Authorization</code>{' '}
        header.
      </p>
    </section>
  )
}

export default Login
